import { Component, Inject, PLATFORM_ID } from '@angular/core'
import { TopbarComponent } from '@components/topbar/topbar.component'
import { LottieComponent, type AnimationOptions } from 'ngx-lottie'
import { Footer12Component } from './component/footer12/footer12.component'
import { RouterModule } from '@angular/router'
import { basePath } from '@states/constants'
import { isPlatformBrowser } from '@angular/common'

@Component({
  selector: 'app-error-v1',
  imports: [TopbarComponent, Footer12Component, RouterModule,LottieComponent],
  templateUrl: './error-v1.component.html',
  styles: ``
})
export class ErrorV1Component {
  options: AnimationOptions | null = null;
  isBrowser = true
  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.options = {
        path: `${basePath}assets/json/animation-404-v1.json`,
        loop: true,
      }
    }
  }
}
